import { Component, OnInit, ViewChild, ElementRef, Inject, ChangeDetectorRef } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import Cropper from 'cropperjs';

import { IUploadType, AspectRatio, ImageActions } from '@app/api/models/media.models';

import { getAspectRatio, cropperPanelClass, cropperPanelEditableClass } from './../../utils/media-management';

@Component({
  selector: 'image-viewer',
  templateUrl: './image-viewer.component.html',
  styleUrls: ['./image-viewer.component.scss'],
  standalone: false,
})
export class ImageViewerComponent implements OnInit {
  @ViewChild('image') imageElement: ElementRef;
  imageSource: string;
  imageType: IUploadType;
  aspectRatio: AspectRatio;
  private cropper: Cropper;

  cropperOpacity = 0;
  editable = false;
  imageTypes = IUploadType;
  aspectRatios = AspectRatio;
  savedImage = '';

  constructor(
    public dialog: MatDialogRef<ImageViewerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  public ngOnInit() {
    const { image, editable, imageType } = this.data;
    this.imageSource = image ? image.url : this.imageSource;
    this.editable = editable ? editable : this.editable;
    this.imageType = imageType;
    this.setAspectRatio();
    this.instantiateCropper();
  }

  public rotateRight(): void {
    this.cropper.rotate(90);
  }

  public rotateLeft(): void {
    this.cropper.rotate(-90);
  }

  public onCloseClick(): void {
    this.dialog.close();
  }

  public saveImage(): void {
    this.cropper.getCroppedCanvas().toBlob(image => {
      this.dialog.close({ image, action: ImageActions.SAVE });
    });
  }

  public deletePhoto(): void {
    this.dialog.close({ action: ImageActions.DELETE });
  }

  /**
   * Turns the edit mode ON
   */
  public editPhoto(): void {
    this.editable = !this.editable;
    this.instantiateCropper();
  }

  /**
   * Instantiates the cropper
   */
  public instantiateCropper(): void {
    this.changeDialogColor();
    this.changeDetectorRef.detectChanges();
    if (this.editable) {
      setTimeout(() => {
        this.cropperOpacity = 1;
      }, 500);
      this.cropper = new Cropper(this.imageElement.nativeElement, {
        zoomable: true,
        scalable: true,
        aspectRatio: 1,
        crop: () => {
          const canvas = this.cropper.getCroppedCanvas();
          this.savedImage = canvas.toDataURL('image/jpg');
        },
      });
    } else {
      this.cropperOpacity = 0;
    }
  }

  /**
   * Changes the dialog color, depending if it's in the Viewer mode or Edit mode
   */
  private changeDialogColor(): void {
    const toRemove = this.editable ? cropperPanelClass : cropperPanelEditableClass;
    const toAdd = this.editable ? cropperPanelEditableClass : cropperPanelClass;
    this.dialog.removePanelClass(toRemove);
    this.dialog.addPanelClass(toAdd);
  }

  /**
   * Sets the aspect ratio of the photo to enable vertical or horizontal layout
   */
  private setAspectRatio(): void {
    const image = new Image();
    image.onload = () => {
      const { width, height } = image;
      this.aspectRatio = getAspectRatio(width, height);
    };
    image.src = this.imageSource;
  }
}
